$(document).ready(function () {
    slides2();
    slides4();
});

function slides2() {
    $('.block-2-slides').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        // centerPadding: "25%",
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    // centerPadding: "25%",
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.8,
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2.5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1.8,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.5,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1.3,
                }
                
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1.1,
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                }
            },
        ],
    });
}


